module.exports = __webpack_public_path__ + "img/general-2.2.188c9fe9.svg";